import { UsersRound } from 'lucide-react';
import ChoixDiscipline from '../components/ChoixDiscipline';
import GestionAdherents from '../components/GestionAdherents';
import { useAuth } from '../hooks/useAuth';

/**
 * Les réglages du registre, à part des Paramètres du site.
 *
 * Ils ne s'adressent pas aux mêmes personnes : les Paramètres appartiennent à
 * l'administrateur de l'association, ceux-ci se confient au trésorier — qui
 * fixe les tarifs — et à l'entraîneur — qui connaît les catégories d'âge de sa
 * fédération. Aucun des deux n'est administrateur du site pour autant, et les
 * noyer dans un écran où l'on règle aussi la messagerie serait leur demander
 * de traverser une pièce qui ne les regarde pas.
 */
export default function AdminAdherentsPage() {
  const { aLeDroit, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!aLeDroit('configurer_adherents')) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-16 text-center">
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Réglages du registre</h1>
        <p className="text-sm text-gray-500">
          Le président, le trésorier et les entraîneurs règlent le registre. Demandez-leur d'ouvrir ce
          droit si vous en avez l'usage.
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <UsersRound className="w-6 h-6 text-primary-600" />
          Réglages du registre
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Saisons, catégories d'âge, licences, pièces réclamées, équipements et rôles d'équipe : ce qui
          distingue votre club de tous les autres.
        </p>
      </div>

      {/* La discipline vient AVANT les réglages, et pas après.

          Un responsable qui arrive ici a un registre à configurer, pas des
          cases à cocher. Lui demander sa fédération d'abord remplit les trois
          quarts de ce qui suit ; lui montrer d'abord des listes vides le fait
          commencer par la saisie à la main, et il ne verra jamais qu'il y
          avait plus court. */}
      <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 p-5 sm:p-6 mb-6">
        <ChoixDiscipline />
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-5 sm:p-6">
        <GestionAdherents />
      </div>
    </div>
  );
}
